import React, {useMemo} from 'react'
import styles from "./index.module.scss";
import {UserI} from "../../../../../types";
import CheckboxActiveIcon from "../../../../../assets/icon/CheckboxActiveIcon";
import CheckboxIcon from "../../../../../assets/icon/CheckboxIcon";
import Avatar from "../../../../Avatar";

interface UsersItemPickerProps {
    user: UserI,
    getUsers: (usersId: string | number) => void,
    isActive?: boolean
}

export default function UsersItemPicker({user, getUsers, isActive}: UsersItemPickerProps) {
    if(!user){
        return null
    }

    return (
        <div className={`${styles.users} ${isActive && styles.active}`} onClick={() => getUsers(user.id)}>
            <div className={styles.users__item}>
                <div className={styles.users__avatar}>
                    <Avatar user={user} />
                    {/*<img src={user.avatar} alt="user avatar"/>*/}
                </div>
                <div>
                    {`${user?.first_name} ${user?.last_name}`.trim()}
                </div>
            </div>
            {isActive ? <CheckboxActiveIcon /> : <CheckboxIcon />}
        </div>
    )
}
